import { isDefinedString } from "et3-type-guards";
import DatePicker from "react-datepicker";

import { TEt3DateTimePicker } from "../../../TypesNEW";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";

const Et3DateTime = withLiteObserverAndTheme<TEt3DateTimePicker>((props) => {
  const {
    label,

    theme,

    onChange,
    selectedDate
  } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      withShadow={false}
      width={350}
      height={75}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {isDefinedString(label) ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={350}
          height={30}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={18}
            text={label}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              height: 18 * unitY,
              paddingTop: 0
            }}
          />
        </ET3Div>
      ) : null}

      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={true}
        width={350}
        height={45}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.white}
        style={{
          borderRadius: 39 * unitX
        }}
        onClick={() => {}}
      >
        <DatePicker
          selected={selectedDate}
          onChange={(event) => {
            onChange(event);
          }}
          showTimeSelect
          className="date-picker"
          timeFormat="HH:mm"
          timeIntervals={20}
          timeCaption="time"
          dateFormat="MMMM d, yyyy h:mm aa"
        />
      </ET3Div>
    </ET3Div>
  );
});
export default Et3DateTime;
